module.exports = window.dnn.nodeModules.Es6Promise;